import { ImageConvertStatus, isImageConvertStatusSuccess } from 'shared/domain/imageConvertStatus/imageConvertStatus';
import { isImageExtension, normalizeFileExtension } from 'shared/utils/fileExtensions';
import { EXTENSIONS } from 'shared/constants/EXTENSIONS';

const MAP_IMAGE_EXTENSIONS = new Set<string>(EXTENSIONS.MAP_IMAGE);

function isMapImageExtension(extension: string | undefined): boolean {
  const normalizedExtension = normalizeFileExtension(extension);
  return isImageExtension(normalizedExtension) && MAP_IMAGE_EXTENSIONS.has(normalizedExtension);
}

export function isPdfExtension(extension: string | undefined): boolean {
  return normalizeFileExtension(extension) === EXTENSIONS.PDF;
}

/** Whether a map can be drawn from a file of this format: a map image or a PDF (a PDF only once converted). */
export function isMapExtension(extension: string | undefined): boolean {
  return isMapImageExtension(extension) || isPdfExtension(extension);
}

export function isSupportedAsMap(
  extension: string,
  imageConvertStatus: ImageConvertStatus | undefined
): boolean {
  return isMapImageExtension(extension) || (isPdfExtension(extension) && isImageConvertStatusSuccess(imageConvertStatus));
}
